import React from 'react';
import {
  node,
  string,
  objectOf,
  oneOfType,
  number,
  bool,
} from 'prop-types';
import variables from '../../styles/variables.module.scss';

const HeadlineLarge = ({
  children,
  stroke,
  strokeColor,
  color,
  lineBreak,
  className,
  style,
  medium,
}) => (
  medium ? (
    <h2 className={[className].join(' ')} style={{ color, ...style }}>
      {children}
      {lineBreak ? <br /> : ' '}
      <span
        style={{
          WebkitTextStroke: `1px ${strokeColor}`,
          color: 'transparent',
        }}
      >
        {stroke}
      </span>
    </h2>
  ) : (
    <h1 className={[className].join(' ')} style={{ color, ...style }}>
      {children}
      {lineBreak ? <br /> : ' '}
      <span
        style={{
          WebkitTextStroke: `1px ${strokeColor}`,
          color: 'transparent',
        }}
      >
        {stroke}
      </span>
    </h1>
  )
);

HeadlineLarge.propTypes = {
  children: node,
  stroke: string,
  className: string,
  color: string,
  style: objectOf(oneOfType([
    string,
    number,
  ])),
  strokeColor: string,
  lineBreak: bool,
  medium: bool,
};

HeadlineLarge.defaultProps = {
  children: null,
  stroke: null,
  className: null,
  style: null,
  strokeColor: variables.springGreen,
  color: null,
  lineBreak: false,
  medium: false,
};

export default HeadlineLarge;
